export default {
  'app.pwa.offline': 'Bạn đang ngoại tuyến',
  'app.pwa.serviceworker.updated': 'Nội dung mới có sẵn',
  'app.pwa.serviceworker.updated.hint':
    'Vui lòng nhấn nút "Làm mới" để tải lại trang',
  'app.pwa.serviceworker.updated.ok': 'Làm mới',
};


